import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron"]

  connect() {
    // Initialize all items as closed
    this.contentTargets.forEach(content => {
      this.closeContent(content)
    })
  }

  toggle(event) {
    const button = event.currentTarget
    const contentId = button.getAttribute('aria-controls')
    const content = this.element.querySelector(`#${contentId}`)
    const chevron = button.querySelector('[data-faq-accordion-target="chevron"]')

    const isOpen = button.getAttribute('aria-expanded') === 'true'

    if (isOpen) {
      this.closeItem(button, content, chevron)
    } else {
      // Close all other items first (accordion behavior)
      this.closeAllItems()
      this.openItem(button, content, chevron)
    }
  }

  openItem(button, content, chevron) {
    // Update button attributes
    button.setAttribute('aria-expanded', 'true')
    button.setAttribute('data-state', 'open')

    // Update content
    content.setAttribute('data-state', 'open')
    content.style.maxHeight = content.scrollHeight + 'px'

    // Rotate chevron
    if (chevron) {
      chevron.style.transform = 'rotate(180deg)'
    }
  }

  closeItem(button, content, chevron) {
    // Update button attributes
    button.setAttribute('aria-expanded', 'false')
    button.setAttribute('data-state', 'closed')

    // Update content
    content.setAttribute('data-state', 'closed')
    content.style.maxHeight = '0'

    // Reset chevron
    if (chevron) {
      chevron.style.transform = 'rotate(0deg)'
    }
  }

  closeAllItems() {
    const allButtons = this.element.querySelectorAll('button[aria-controls]')
    const allContents = this.contentTargets
    const allChevrons = this.chevronTargets

    allButtons.forEach((button, index) => {
      const content = allContents[index]
      const chevron = allChevrons[index]

      if (button && content) {
        this.closeItem(button, content, chevron)
      }
    })
  }

  closeContent(content) {
    content.style.maxHeight = '0'
    content.setAttribute('data-state', 'closed')
  }
}
